export default __webpack_public_path__ + "static/media/adobe.78367a52.png";